import { getLog } from '@aurora/shared-utils/log';
import React from 'react';
import useCommunityCookieProperties from '@aurora/shared-client/components/community/useCommunityCookieProperties';
import useQueryWithTracing from '@aurora/shared-client/components/useQueryWithTracing';
import {
  GdprCookieValues,
  getFunctionalCookieStatus
} from '@aurora/shared-client/helpers/cookie/CookieHelper';
import surveyBehavior from '@aurora/shared-client/components/surveys/ValueSurveyBehavior.query.graphql';
import type {
  ValueSurveyBehaviorQuery,
  ValueSurveyBehaviorQueryVariables
} from '../../../types/graphql-types';
import SurveyLauncherContent from '../SurveyLauncherContent/SurveyLauncherContent';

const log = getLog(module);

/**
 * Survey Launcher component, handles the logic for when to launch the survey
 *
 * @author Adam Ayres
 */
const SurveyLauncher: React.FC = () => {
  const functionalCookiesAccepted = getFunctionalCookieStatus() == GdprCookieValues.ACCEPTED;
  const {
    data: cookieData,
    loading: cookieLoading,
    error: cookieError
  } = useCommunityCookieProperties(module);
  const {
    data: surveyBehaviorData,
    loading,
    error: surveyError
  } = useQueryWithTracing<ValueSurveyBehaviorQuery, ValueSurveyBehaviorQueryVariables>(
    module,
    surveyBehavior
  );

  if (loading || cookieLoading) {
    return null;
  }

  if (cookieError || surveyError) {
    log.error('Error loading survey data');
    return null;
  }

  return (
    <SurveyLauncherContent
      cookieProperties={cookieData.community.cookieProperties}
      surveyBehaviorData={surveyBehaviorData}
      functionalCookiesAccepted={functionalCookiesAccepted}
    />
  );
};

export default SurveyLauncher;
